import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileContract, faCheckCircle } from '@/fontawesome';
import Modal from '@/components/ui/Modal';
import type { LegalContent } from '@/content/legal/impressum';

interface LegalDocumentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAccept: () => void;
  content: LegalContent;
  icon?: React.ReactNode;
}

export default function LegalDocumentModal({
  isOpen,
  onClose,
  onAccept,
  content,
  icon
}: LegalDocumentModalProps) {
  const handleAccept = () => {
    onAccept();
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={content.title}
      icon={icon || <FontAwesomeIcon icon={faFileContract} className="w-5 h-5 text-blue-600 dark:text-blue-400" />}
      maxWidth="4xl"
      closeDisabled={false}
    >
      <div className="flex flex-col h-[70vh]">
        {/* Scrollable Content */}
        <div
          className="flex-1 overflow-y-auto px-6 py-4 bg-gray-50 dark:bg-gray-900/50 rounded-lg mb-6"
        >
          <div className="prose dark:prose-invert max-w-none">
            {content.sections.map((section, index) => (
              <div key={index} className="mb-6">
                {section.title && (
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-3">
                    {section.title}
                  </h3>
                )}
                {section.content.map((paragraph, pIndex) => (
                  <p
                    key={pIndex}
                    className={`text-sm text-gray-700 dark:text-gray-300 ${
                      paragraph === '' ? 'mb-2' : 'mb-4'
                    }`}
                  >
                    {paragraph}
                  </p>
                ))}
              </div>
            ))}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end gap-3 px-6 pb-6">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-lg transition-colors cursor-pointer"
          >
            Abbrechen
          </button>
          <button
            onClick={handleAccept}
            className="px-6 py-2 rounded-lg font-medium transition-all flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white cursor-pointer"
          >
            <FontAwesomeIcon icon={faCheckCircle} className="w-4 h-4" />
            <span>Akzeptieren und schließen</span>
          </button>
        </div>
      </div>
    </Modal>
  );
}
